import { useEffect, useState } from "react";
import Lenis from "lenis";
import { setLenis, scrollToId } from "@/lib/site";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { ServiceStrip } from "@/components/site/ServiceStrip";
import { Commercial } from "@/components/site/Commercial";
import { ServiceBlocks } from "@/components/site/ServiceBlocks";
import { Process } from "@/components/site/Process";
import { Faq } from "@/components/site/Faq";
import { QuoteRequest } from "@/components/site/QuoteRequest";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFab } from "@/components/site/WhatsAppFab";

export default function Home() {
  const [service, setService] = useState("comercial");
  const [visit, setVisit] = useState(false);
  const pick = (s, v = false) => { setService(s); setVisit(v); scrollToId("orcamento"); };

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    setLenis(lenis);
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); setLenis(null); };
  }, []);

  return (
    <main className="bg-[#FAF8F5] text-[#121518] overflow-x-hidden">
      <Nav />
      <Hero onPick={pick} />
      <ServiceStrip />
      <Marquee />
      <Commercial onPick={pick} />
      <ServiceBlocks onPick={pick} />
      <Process />
      <Faq />
      <QuoteRequest service={service} setService={setService} visit={visit} setVisit={setVisit} />
      <Footer />
      <WhatsAppFab />
    </main>
  );
}
